import { render, staticRenderFns } from "./FormGuideEventHeader.vue?vue&type=template&id=50b39900"
import script from "./FormGuideEventHeader.vue?vue&type=script&lang=js"
export * from "./FormGuideEventHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports